/**
 * @generated SignedSource<<9f8a29f3a6a8f0bf7ed3ee483fc89417>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetCalendarOverviewUpdateInput = {
  setCalendarIds: ReadonlyArray<string>;
};
export type WSCalendarOverviewMutation$variables = {
  id: string;
  input: WidgetCalendarOverviewUpdateInput;
  storecastId: string;
};
export type WSCalendarOverviewMutation$data = {
  readonly dashboard: {
    readonly updateWidgetCalendarOverview: {
      readonly calendars: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"WidgetCalendarOverview_widget">;
    };
  };
};
export type WSCalendarOverviewMutation = {
  response: WSCalendarOverviewMutation$data;
  variables: WSCalendarOverviewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "dashboardId",
    "variableName": "storecastId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "update",
    "variableName": "input"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "includeExternal",
      "value": true
    }
  ],
  "concreteType": "StoreCalendar",
  "kind": "LinkedField",
  "name": "calendars",
  "plural": true,
  "selections": [
    (v5/*: any*/)
  ],
  "storageKey": "calendars(includeExternal:true)"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WSCalendarOverviewMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "DashboardMutation",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "WidgetCalendarOverview",
            "kind": "LinkedField",
            "name": "updateWidgetCalendarOverview",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WidgetCalendarOverview_widget"
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "WSCalendarOverviewMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "DashboardMutation",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "WidgetCalendarOverview",
            "kind": "LinkedField",
            "name": "updateWidgetCalendarOverview",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "37b0e6bfdd63431650e75f516c8bb095",
    "id": null,
    "metadata": {},
    "name": "WSCalendarOverviewMutation",
    "operationKind": "mutation",
    "text": "mutation WSCalendarOverviewMutation(\n  $storecastId: ID!\n  $id: ID!\n  $input: WidgetCalendarOverviewUpdateInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    updateWidgetCalendarOverview(id: $id, update: $input) {\n      id\n      ...WidgetCalendarOverview_widget\n      calendars(includeExternal: true) {\n        id\n      }\n    }\n  }\n}\n\nfragment WidgetCalendarOverview_widget on WidgetCalendarOverview {\n  id\n  title\n}\n"
  }
};
})();

(node as any).hash = "8ee79be5c99646b1708a76b7506caa4d";

export default node;
